<template>
  <div></div>
</template>
    
<script>
export default {
  name: "AddAddressView",
  components: {},
};
</script>